export enum Roles {
    ADMIN = 'ADMIN',
    USER = 'USER'
}
